import { Component, Input } from '@angular/core';

import { ParticipantPriceType } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { FixtureParticipantPriceMap, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { HorseRacingCommon } from '@frontend/sports/types/components/sitecore';

import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';

@Component({
    selector: 'ms-resulted-placed-participants',
    templateUrl: 'resulted-placed-participants.component.html',
    standalone: false,
})
export class ResultedPlacedParticipantsComponent {
    @Input() participants: WinGameParticipant[];
    @Input() prices: FixtureParticipantPriceMap = {};
    @Input() participantOptionGroups: any;
    @Input() isOptionBet: boolean;
    @Input() isFavourites: boolean;
    constructor(
        public siteCore: Sitecore,
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
    ) {}

    getParticipantOption(id: number) {
        const option = this.horsesFixturePricingHelper.getParticipantOptions(id, this.participantOptionGroups, ParticipantPriceType.Fixed);

        return option ? option?.nativePrice.toJSON() : undefined;
    }

    sitecoreCommonIndex(index: number) {
        return this.siteCore.horseRacing.common[(index + 1) as any as keyof HorseRacingCommon];
    }
}
